export default __webpack_public_path__ + "static/media/Softphone.9b57d50d.jpg";